import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7f8fcb10"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "text-inputs",
  class: "input-combo"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Text input", -1))
const _hoisted_3 = { "data-test": "text-input-field-container" }
const _hoisted_4 = ["value"]
const _hoisted_5 = { "data-test": "text-output" }
const _hoisted_6 = {
  id: "select-input",
  class: "input-combo"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Select input", -1))
const _hoisted_8 = { "data-test": "select-inputs-container" }
const _hoisted_9 = ["value"]
const _hoisted_10 = ["data-test"]
const _hoisted_11 = { "data-test": "select-output" }
const _hoisted_12 = {
  id: "checkbox-input",
  class: "input-combo",
  "data-test": "checkbox-container"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Checkboxes", -1))
const _hoisted_14 = ["for"]
const _hoisted_15 = ["id", "value", "data-test"]
const _hoisted_16 = { "data-test": "checkbox-output" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = {
  id: "radio-input",
  class: "input-combo"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Radio buttons", -1))
const _hoisted_21 = ["data-test"]
const _hoisted_22 = ["for", "data-test"]
const _hoisted_23 = ["id", "value", "data-test"]
const _hoisted_24 = { "data-test": "radio-output" }
const _hoisted_25 = {
  id: "color-input",
  class: "input-combo"
}
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Color inputs", -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "color-input" }, "Choose a color", -1))
const _hoisted_28 = ["value"]
const _hoisted_29 = {
  class: "color-input",
  "data-test": "color-output"
}
const _hoisted_30 = { id: "range-input" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Range input", -1))
const _hoisted_32 = ["value"]
const _hoisted_33 = { "data-test": "range-output" }

import {ref} from "vue";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

_useCssVars(_ctx => ({
  "5dc4a198": (colorInput.value)
}))

const inputOptions = [
  {
    name: 'Lisa',
    id: 1
  },
  {
    name: 'Hannes',
    id: 2
  },
  {
    name: 'Lutz',
    id: 3
  },
  {
    name: '??',
    id: 4
  },
]

const textInput = ref('Initial value');
const selectInput = ref('');
const checkboxInput= ref([]);
const radioInput = ref('');
const colorInput = ref('#00ff00');
const rangeInput= ref(0);

const updateTextInput = (event: any) => {
  return textInput.value = event.target.value;
};

const updateSelectInput = (event: any) => {
  return selectInput.value = event.target.value;
};

const updateRadioInput = (event: any) => {
  return radioInput.value = event.target.value;
};

const updateColorInput = (event: any) => {
  console.log(event.target.value);
  return colorInput.value = event.target.value;
};

const updateRangeInput = (event: any): number => {
  return rangeInput.value = event.target.value;
};

const updateCheckboxInput = (event: any) => {
  if (checkboxInput.value.includes(event.target.value)) {
    const indexOfDeletedItem = checkboxInput.value.indexOf(event.target.value);
    checkboxInput.value.splice(indexOfDeletedItem,1);
  } else {
    return checkboxInput.value.push(event.target.value);
  }
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("input", {
          type: "text",
          value: textInput.value,
          onInput: updateTextInput,
          "data-test": "text-input-field"
        }, null, 40, _hoisted_4)
      ]),
      _createElementVNode("div", _hoisted_5, _toDisplayString(textInput.value), 1)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _hoisted_7,
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("select", {
          value: selectInput.value,
          onInput: updateSelectInput
        }, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(inputOptions, (selectOption) => {
            return _createElementVNode("option", {
              key: selectOption.id,
              "data-test": `select-input-${selectOption.id}`
            }, _toDisplayString(selectOption.name), 9, _hoisted_10)
          }), 64))
        ], 40, _hoisted_9)
      ]),
      _createElementVNode("div", _hoisted_11, _toDisplayString(selectInput.value), 1)
    ]),
    _createElementVNode("div", _hoisted_12, [
      _hoisted_13,
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(inputOptions, (checkboxOption) => {
        return _createElementVNode("div", {
          key: checkboxOption.id+checkboxOption.name
        }, [
          _createElementVNode("label", {
            for: checkboxOption.name
          }, _toDisplayString(checkboxOption.name), 9, _hoisted_14),
          _createElementVNode("input", {
            type: "checkbox",
            id: checkboxOption.name,
            value: checkboxOption.name,
            onInput: updateCheckboxInput,
            "data-test": `checkbox-${checkboxOption.id}`
          }, null, 40, _hoisted_15)
        ])
      }), 64)),
      _createElementVNode("div", _hoisted_16, [
        (checkboxInput.value.length)
          ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(checkboxInput.value.join(', ')), 1))
          : (_openBlock(), _createElementBlock("span", _hoisted_18, "None selected"))
      ])
    ]),
    _createElementVNode("div", _hoisted_19, [
      _hoisted_20,
      _createElementVNode("form", null, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(inputOptions, (radioButtonOption) => {
          return _createElementVNode("div", {
            key: radioButtonOption.id+radioButtonOption.name,
            "data-test": `radio-container-${radioButtonOption.id}`
          }, [
            _createElementVNode("label", {
              for: radioButtonOption.name,
              "data-test": `radio-label-${radioButtonOption.id}`
            }, _toDisplayString(radioButtonOption.name), 9, _hoisted_22),
            _createElementVNode("input", {
              type: "radio",
              name: "radioNames",
              id: radioButtonOption.name,
              value: radioButtonOption.name,
              onInput: updateRadioInput,
              "data-test": `radio-input-${radioButtonOption.id}`
            }, null, 40, _hoisted_23)
          ], 8, _hoisted_21)
        }), 64))
      ]),
      _createElementVNode("div", _hoisted_24, _toDisplayString(radioInput.value), 1)
    ]),
    _createElementVNode("div", _hoisted_25, [
      _hoisted_26,
      _createElementVNode("div", null, [
        _hoisted_27,
        _createElementVNode("input", {
          type: "color",
          id: "color-input-element",
          value: colorInput.value,
          onInput: updateColorInput,
          "data-test": "color-input-element"
        }, null, 40, _hoisted_28)
      ]),
      _createElementVNode("div", _hoisted_29, _toDisplayString(colorInput.value), 1)
    ]),
    _createElementVNode("div", _hoisted_30, [
      _hoisted_31,
      _createElementVNode("input", {
        type: "range",
        min: "0",
        max: "10",
        value: rangeInput.value,
        onInput: updateRangeInput,
        "data-test": "range-input"
      }, null, 40, _hoisted_32),
      _createElementVNode("div", _hoisted_33, _toDisplayString(rangeInput.value), 1)
    ])
  ], 64))
}
}

})